// extracted by mini-css-extract-plugin
module.exports = {"text":"CheckoutPayButtonContent_text___lGaF"};